module.exports = __webpack_public_path__ + "02_short_brown.1f7f4a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_short_brown.png
// module id = c6vB
// module chunks = 0